import { jsx as t } from "react/jsx-runtime";
import "react";
import { classes as _ } from "./utils/helpers.js";
import './assets/ChoicesItem.css';const c = {
  "custom-select": "_custom-select_m42hg_1",
  "custom-select__select": "_custom-select__select_m42hg_9",
  "custom-select__selection": "_custom-select__selection_m42hg_16",
  "custom-select__selections": "_custom-select__selections_m42hg_16",
  "custom-select__selected": "_custom-select__selected_m42hg_34",
  "custom-select__remove": "_custom-select__remove_m42hg_44",
  "custom-select__choices-wrapper": "_custom-select__choices-wrapper_m42hg_61",
  "custom-select__choices": "_custom-select__choices_m42hg_61",
  "custom-select__choices-wrapper--hidden": "_custom-select__choices-wrapper--hidden_m42hg_98",
  "custom-select__icon": "_custom-select__icon_m42hg_102",
  "custom-select__icon--chevron": "_custom-select__icon--chevron_m42hg_115",
  "custom-select__item--selected": "_custom-select__item--selected_m42hg_123",
  "custom-select__item--highlighted": "_custom-select__item--highlighted_m42hg_128",
  "custom-select__select--touched": "_custom-select__select--touched_m42hg_131"
};
function h({ item: e, handleOnClick: s }) {
  return /* @__PURE__ */ t(
    "li",
    {
      onClick: () => s(e.id),
      id: e.id,
      className: _([
        e.status === "selected" ? `${c["custom-select__item--selected"]} custom-select__item--selected` : "",
        e.status === "highlighted" ? `${c["custom-select__item--highlighted"]} custom-select__item--highlighted` : ""
      ]),
      children: e.label
    },
    e.id
  );
}
export {
  h as C,
  c as s
};
